export * from './component-settings';

export interface BaseProps {
  className?: string;
  dataHook?: string;
  id?: string;
  attributes?: any;
  innerText?: string;
  ariaLabel?: string;
  ariaLabelledBy?: string;
  ariaDescribedBy?: string;
}

export const DEFAULT_POLICY: ConsentPolicy = {
  essential: true,
  functional: false,
  analytics: false,
  advertising: false,
};

export const DEFAULT_POLICY_DETAILS: PolicyDetails = {
  defaultPolicy: true,
  policy: DEFAULT_POLICY,
};

type PolicySuccessCallback = (policy: ConsentPolicy) => void;
type PolicyErrorCallback = (error: Error) => void;
type GetCurrentConsentPolicy = () => PolicyDetails;
type ResetPolicy = () => void;
type SetConsentPolicy = (
  newPolicy: ConsentPolicy,
  successCallback?: PolicySuccessCallback,
  errorCallback?: PolicyErrorCallback,
) => void;

export interface PolicyDetails {
  defaultPolicy: boolean;
  policy?: ConsentPolicy;
  createdDate?: Date | any;
}

export interface ConsentPolicy {
  essential: boolean;
  functional: boolean;
  analytics: boolean;
  advertising: boolean;
  dataToThirdParty?: boolean;
}

export interface BaseComponentProps {}
export type IState = {
  [key: string]: any;
};

export abstract class BaseComponent<
  P extends BaseComponentProps,
  S extends IState
> {
  static defaultProps: any;
  props: P;
  protected state: S;
  htmlElement!: HTMLElement;
  abstract render(): HTMLElement;
  rendered = false;

  constructor(props?: P) {
    this.props = {
      ...(props || Object.create({})),
      ...BaseComponent.defaultProps,
    };
    this.state = Object.create({});
  }

  setState(partial: Partial<S>) {
    this.state = {
      ...this.state,
      ...partial,
    };
    // const parent = this.htmlElement?.parentElement;
    // if (parent) {
    //   parent.removeChild(this.htmlElement);
    //   renderComponent(this, parent);
    // }
  }

  componentRendered(): void {
    // No-Op
  }

  onComponentUpdate(): void {}
}
